import { exists } from '@/api'

export interface BatchTrcAuthorityUpdateCondition {
  startNumFrom: string
  startNumTo: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  memo: string
}

export function BatchTrcAuthorityUpdateConditionFromJSON(
  json: any
): BatchTrcAuthorityUpdateCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    convertHyoukiToFull: exists(_json, 'convert_hyouki_to_full')
      ? _json.convert_hyouki_to_full
      : false,
    convertKanaToHalf: exists(_json, 'convert_kana_to_half')
      ? _json.convert_kana_to_half
      : false,
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
